@if (card(); as notificationCard) {
    <div class="dashboard-notification" (click)="onSelect()">
        <div class="card-header row justify-content-between">
            <div class="col-auto">
                <p class="notification-date m-0">{{ notificationCard.weekday }} {{ notificationCard.startDateTime }}</p>
            </div>
            <div class="col-auto">
                <div class="row">
                    @if (notificationCard.isEscalated) {
                        <div class="col-auto card-header-icon ps-2">
                            <fa-icon [icon]="faExclamationTriangle" size="lg" class="red"></fa-icon>
                        </div>
                    }
                    @if (notificationCard.isCancelled) {
                        <div class="col-auto card-header-icon ps-0">
                            <fa-icon [icon]="faBan" size="lg" class="red"></fa-icon>
                        </div>
                    }
                </div>
            </div>
        </div>
        @if (notificationCard.isMultiDay) {
            <p class="notification-date m-0">
                {{ notificationCard.multiDayWeekday }} {{ notificationCard.multiDayEndDateTime }}
            </p>
        }
        <p class="name m-0">{{ notificationCard.customerName }}</p>
        <p class="notification-type m-0">{{ notificationCard.notificationType }}</p>
        @if (notificationCard.tidnr) {
            <p class="m-0">
                {{ notificationCard.tidnr }}
                <span class="serial-no">{{ notificationCard.serialNumber }} </span>
                <span>{{ notificationCard.productName }}</span>
            </p>
        }
        @if (notificationCard.affectedEquipment.length > 0) {
            <p
                class="m-0"
                [class.text-clipped]="!hasContentBelowClarifyText() && notificationCard.clarifyTextHtml.length === 0"
            >
                <span>{{ notificationCard.affectedEquipmentLabel }}</span
                >:
                {{ notificationCard.affectedEquipment }}
            </p>
        }
        @if (notificationCard.clarifyTextHtml) {
            <p
                class="m-0"
                [class.text-clipped]="!hasContentBelowClarifyText()"
                [innerHTML]="notificationCard.clarifyTextHtml"
            ></p>
        }
        @if (notificationCard.trackerUrl && notificationCard.noOfOrderedMaterials) {
            <!-- The link opens in a new tab on its own, so it needs no click handling beyond
                 keeping the click off the card. -->
            <p class="additional-info m-0" (click)="$event.stopPropagation()">
                <a class="pace-link" [href]="notificationCard.trackerUrl" target="_blank">{{
                    notificationCard.trackAllOrdersLabel
                }}</a>
            </p>
        }
        <div class="card-footer row justify-content-between">
            <div class="col-auto align-self-end">
                @if (severityIcon(); as icon) {
                    <fa-icon [icon]="icon" size="lg" [class]="severityColorClass()"></fa-icon>
                }
            </div>
            <div class="col-auto card-footer-right">
                <div class="row justify-content-end align-items-center">
                    @if (notificationCard.noOfParticipants) {
                        <div class="col-auto card-footer-icon pe-0 ps-2">
                            <span class="pe-1">{{ notificationCard.noOfParticipants }}</span>
                            <fa-icon [icon]="faParticipants"></fa-icon>
                        </div>
                    }
                    @if (notificationCard.noOfOrderedMaterials) {
                        <div class="col-auto card-footer-icon pe-0 ps-2">
                            <span class="pe-1">{{ notificationCard.noOfOrderedMaterials }}</span>
                            <fa-icon [icon]="faBox" size="lg"></fa-icon>
                        </div>
                    }
                    @if (notificationCard.isRemoteSupport) {
                        <div class="col-auto card-footer-icon pe-0 ps-2">
                            <fa-icon [icon]="faPhone" size="lg"></fa-icon>
                        </div>
                    }
                    @if (notificationCard.formsAvailable.length > 0) {
                        <div class="col-auto card-footer-icon pe-0 ps-2">
                            <fa-icon [icon]="faFileInvoice" size="lg"></fa-icon>
                        </div>
                    }
                    <div class="col-auto card-footer-btn ps-2">
                        <pace-status-badge
                            [badge]="notificationCard.badge"
                            [showEscalatedIcon]="false"
                            [showCancelledIcon]="false"
                        ></pace-status-badge>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
